"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _constants = require("./constants");

var _sx = _interopRequireDefault(require("./sx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const hoverColor = (0, _styledSystem.system)({
  hoverColor: {
    property: 'color',
    scale: 'colors'
  }
});

const Link = _styledComponents.default.a.withConfig({
  displayName: "Link",
  componentId: "sc-1brdqhf-0"
})(["color:", ";text-decoration:", ";&:hover{text-decoration:", ";", ";}&:is(button){display:inline-block;padding:0;font-size:inherit;white-space:nowrap;cursor:pointer;user-select:none;background-color:transparent;border:0;appearance:none;}", ";", ";", ";"], props => props.muted ? (0, _constants.get)('colors.text.secondary')(props) : (0, _constants.get)('colors.text.link')(props), props => props.underline ? 'underline' : 'none', props => props.muted ? 'none' : 'underline', props => props.hoverColor ? hoverColor : props.muted ? `color: ${(0, _constants.get)('colors.text.link')(props)}` : '', _constants.TYPOGRAPHY, _constants.COMMON, _sx.default);

var _default = Link;
exports.default = _default;